/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Reason_PlaceholderInputs */

const en_search_reason_placeholder = /** @type {(inputs: Search_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search reason...`)
};

const es_search_reason_placeholder = /** @type {(inputs: Search_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar motivo...`)
};

/**
* | output |
* | --- |
* | "Search reason..." |
*
* @param {Search_Reason_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_reason_placeholder = /** @type {((inputs?: Search_Reason_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Reason_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_reason_placeholder(inputs)
	return es_search_reason_placeholder(inputs)
});